import * as actionTypes from "./actionTypes";
import apiAlpha from "./apiAlpha";
import { sendHttpRequest } from "actions/actionCreators/httpActions";
import { showError } from "actions/actionCreators/snackbarActions";

export function loadDecisionSummary(documentId, siteId) {
  return async (dispatch, getState) => {
    const key = `${documentId}-${siteId}`;
    let loading = false,
      loaded = false;
    const summary = getState().document.decision.summary[key];
    if (summary) {
      loading = summary.loading;
      loaded = summary.loaded;
    }

    if (loading || loaded) return;

    try {
      dispatch({ type: actionTypes.LOAD_DECISION_SUMMARY_STARTED, id: key });
      const decisionSummary = await dispatch(sendHttpRequest(apiAlpha.loadDecisionSummary(documentId, siteId)));
      dispatch({ type: actionTypes.LOAD_DECISION_SUMMARY_SUCCESS, payload: decisionSummary, id: key });
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}
